// src/components/user/Masivo/SubmissionProgress.jsx
import React from 'react';
import { Loader2, PackageCheck, MessageCircle, Database } from 'lucide-react';

function SubmissionProgress({ 
  total, 
  created, 
  messagesSent, 
  currentStage // 'saving' | 'sending_messages' | 'complete'
}) {
  const savePercentage = total > 0 ? Math.round((created / total) * 100) : 0;
  const messagePercentage = total > 0 ? Math.round((messagesSent / total) * 100) : 0;

  return (
    <div className="bg-white rounded-2xl border-2 border-slate-200 p-6 sm:p-8">
      <div className="flex flex-col items-center justify-center text-center">
        {/* Main icon */}
        <div className="w-20 h-20 rounded-full bg-gradient-to-br from-brand-primary to-brand-green flex items-center justify-center mb-6 relative">
          {currentStage === 'complete' ? (
            <PackageCheck className="w-10 h-10 text-white" />
          ) : (
            <>
              <Loader2 className="w-10 h-10 text-white animate-spin" />
              <div className="absolute inset-0 rounded-full border-4 border-white/30 animate-pulse" />
            </>
          )}
        </div>

        {/* Title */}
        <h2 className="text-2xl font-extrabold text-brand-primary font-montserrat mb-2">
          {currentStage === 'saving' && 'Creando entregas...'}
          {currentStage === 'sending_messages' && 'Enviando mensajes WhatsApp...'}
          {currentStage === 'complete' && '¡Proceso completado!'}
        </h2>

        <p className="text-sm text-slate-600 font-montserrat mb-8">
          {currentStage === 'saving' && `Guardando ${total} entregas en la base de datos`}
          {currentStage === 'sending_messages' && 'Notificando a los clientes'}
          {currentStage === 'complete' && 'Todas las entregas han sido procesadas'}
        </p>

        {/* Progress stages */}
        <div className="w-full max-w-md space-y-6">
          {/* Saving stage */}
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <Database className={`w-5 h-5 ${
                  currentStage === 'saving' ? 'text-brand-primary animate-pulse' : 
                  savePercentage === 100 ? 'text-brand-green' : 'text-slate-300'
                }`} />
                <span className="text-sm font-semibold text-slate-700 font-montserrat">
                  Guardando entregas
                </span>
              </div>
              <span className="text-sm font-bold text-slate-900 font-montserrat">
                {created}/{total}
              </span>
            </div>
            <div className="bg-slate-200 rounded-full h-2 overflow-hidden">
              <div 
                className="bg-gradient-to-r from-brand-primary to-brand-green h-full transition-all duration-300 ease-out"
                style={{ width: `${savePercentage}%` }}
              />
            </div>
          </div>

          {/* WhatsApp messages stage */}
          <div className="space-y-2">
            <div className="flex items-center justify-between">
              <div className="flex items-center gap-2">
                <MessageCircle className={`w-5 h-5 ${
                  currentStage === 'sending_messages' ? 'text-brand-primary animate-pulse' : 
                  messagePercentage === 100 ? 'text-brand-green' : 'text-slate-300'
                }`} />
                <span className="text-sm font-semibold text-slate-700 font-montserrat">
                  Enviando mensajes
                </span>
              </div>
              <span className="text-sm font-bold text-slate-900 font-montserrat">
                {messagesSent}/{total}
              </span>
            </div>
            <div className="bg-slate-200 rounded-full h-2 overflow-hidden">
              <div 
                className="bg-gradient-to-r from-brand-primary to-brand-green h-full transition-all duration-300 ease-out"
                style={{ width: `${messagePercentage}%` }}
              />
            </div>
          </div>
        </div>

        {/* Status message */}
        {currentStage !== 'complete' && (
          <div className="mt-8 flex items-center gap-2 text-slate-400">
            <Loader2 className="w-4 h-4 animate-spin" />
            <span className="text-xs font-montserrat">
              {currentStage === 'saving' && 'Esto puede tomar unos momentos...'}
              {currentStage === 'sending_messages' && 'Enviando notificaciones...'}
            </span>
          </div>
        )}
      </div>
    </div>
  );
}

export default SubmissionProgress;